module.exports = __webpack_public_path__ + "img/order-food.eb0bcbc8.svg";